module.exports = __webpack_public_path__ + "static/media/yahoo.1763dce8.svg";